class NovaProductCardAsync extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const productHandle = this.dataset.handle
    this.loadProductCard = this.loadProductCard.bind(this)

    this.loadProductCard(productHandle)
  }

  loadProductCard(productHandle) {
    fetch(`/products/${productHandle}?view=card`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        this.innerHTML = html.querySelector('.product-view-card').innerHTML

        const card = this.querySelector('nova-product-card')
        const optionValuesTemplate = this.querySelector(
          `#async-options-json-${card.id}`,
        )
        const variantsTemplate = this.querySelector(
          `#async-variants-json-${card.id}`,
        )
        const productOptions = optionValuesTemplate
          ? JSON.parse(optionValuesTemplate.content.textContent.trim())
          : []
        const variants = variantsTemplate
          ? JSON.parse(variantsTemplate.content.textContent.trim())
          : []
        card.productOptions = productOptions.filter(
          (item) => item.name !== 'Title',
        )
        card.variants = variants
      })
  }
}

customElements.define('nova-product-card-async', NovaProductCardAsync)
